import { isWhiteish } from 'src/app/@utils/is-whiteish.helper';

import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlToKeyNamePipe } from '@shared/form-elements/pipes/control-to-key-name.pipe';
import { NgClass, NgStyle } from '@angular/common';

@Component({
    selector: 'app-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    imports: [NgClass, FormsModule, ReactiveFormsModule, NgStyle, ControlToKeyNamePipe]
})
export class RadioComponent implements OnInit {
    public isWhiteish = false;

    @Input() control: AbstractControl;
    @Input() value: any;

    @Input() color = '#000000';
    @Input() checked = false;
    @Input() inverted = false;
    @Input() inline = false;
    @Input() fullWidth = false;
    @Input() contentType: 'text' | 'element' | 'hidden' = 'text';
    @Input() set disabled(value: boolean) {
        if (value) {
            this.formControl.disable();
        } else {
            this.formControl.enable();
        }
    }

    ngOnInit(): void {
        this.isWhiteish = isWhiteish(this.color);
    }

    public get formControl(): UntypedFormControl {
        return this.control as UntypedFormControl;
    }
}
